import React from 'react';
import QRCode from 'qrcode.react';
import { FormattedMessage, injectIntl, defineMessages } from "react-intl";
import { IconArrowLeft, IconCopy } from '../../icons/svg';
import { SCREEN } from '../info-view-content.jsx';
import { DOMAIN_GROUP_INVITE, XXTEA_KEY_DEFAULT } from '../../config.js'
import formatter from '../../services/formatter'
import { Topic } from '../../tinode/topic.js'
import { Tinode } from '../../tinode/tinode.js'
import { copyTextToClipboard } from '../../lib/utils.js'
import Helpers from "../../lib/helpers";
import GroupService from '../../services/group.js';

const messages = defineMessages({
  invite_group_title: {
    id: "invite_group_title",
    defaultMessage: "Invite to join the group",
    description: "Invite to join the group",
  },
  invite_group_desc: {
    id: "invite_group_desc",
    defaultMessage: "Invite friends to join the group",
    description: "Invite friends to join the group",
  },
  invite_group_sub_desc: {
    id: "invite_group_sub_desc",
    defaultMessage: "Scan the QR code or share the link below",
    description: "Scan the QR code or share the link below",
  },
  share_link_button: {
    id: "share_link_button",
    defaultMessage: "Share the link",
    description: "Share the link",
  },
  copy_success: {
    id: 'copy_success',
    defaultMessage: 'Copied successfully',
    description: 'Copied successfully'
  },
  create_qr_link_to_invite: {
    id: "create_qr_link_to_invite",
    defaultMessage: "Let's start creating a link to invite your friends to join your group",
    description: "Let's start creating a link to invite your friends to join your groupw"
  },
  create_link_button: {
    id: "create_link_button",
    defaultMessage: "Create Link",
    description: "Create Link"
  },
  cancel_link_button: {
    id: "cancel_link_button",
    defaultMessage: "Cancel Link",
    description: "Cancel Link"
  },
  notify_error: {
		id: "notify_error",
		defaultMessage: "An error occurred. Please try again later",
		description: "Notify error",
  },
})

const LINK_STATE = {
  ENABLE: 1,
  DISABLE: 0,
}

class QRCodeInvite extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inviteUrl: null,
      linkState: false
    }

    this.onShareInviteLink = this.onShareInviteLink.bind(this)
    this.onCreateInviteLink = this.onCreateInviteLink.bind(this)
    this.getGroupLinkState = this.getGroupLinkState.bind(this)
  }

  componentDidMount() {
    const inviteUrl = this.getQRCodeInviteUrl();
    this.setState({
      inviteUrl: inviteUrl
    })

    this.getGroupLinkState()
  }

  async getGroupLinkState() {
    const { topic } = this.props
    const groupId = Topic.getThreadId(topic)

    const groupInfo = await GroupService.getGroupDetail(groupId)
    console.log('===========groupInfo', groupId, groupInfo)
    let linkState = true
    if (groupInfo== null || groupInfo?.code === 201) {
      linkState = false
    }

    this.setState({ linkState: linkState })
  }

  getQRCodeInviteUrl() {
    const { topic } = this.props

    const groupId = Topic.getThreadId(topic)
    const groupIdEnc = formatter.xxteaEncrypt(groupId, XXTEA_KEY_DEFAULT)

    const url = `${DOMAIN_GROUP_INVITE}/g/${groupIdEnc}`

    return url
  }

  onCopyUrl = (e) => {
    e.preventDefault()
    const { inviteUrl } = this.state
    const { formatMessage } = this.props.intl;
    copyTextToClipboard(inviteUrl)
    Helpers.showSuccessToasts(formatMessage(messages.copy_success));
  }

  onShareInviteLink = (e) => {
    e.preventDefault()

    const { topic: topicName } = this.props
    const { inviteUrl } = this.state

    const topic = this.props.tinode.getTopicByName(topicName)
    const groupName = Topic.getTopicName(topic)

    const data = {
      topic,
      inviteUrl,
      groupName,
    }
    this.props.onShowDialog(Tinode.DIALOG_TYPE.SHARE_INVITE_GROUP_LINK, data)
  }

  onCreateInviteLink = async (state) => {
    const { formatMessage } = this.props.intl;
    const { topic } = this.props
    const groupId = Topic.getThreadId(topic)

    const result = await GroupService.setLinkState(groupId, state)
    console.log('======onCreateInviteLink', result)
    if (result && result.code === 200) {
      if (state === LINK_STATE.ENABLE) {
        this.setState({ linkState: true })
      } else {
        this.setState({ linkState: false })
      }
    } else {
      Helpers.showErrorToasts(formatMessage(messages.notify_error))
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { inviteUrl, linkState } = this.state

    return (
      <div className="info-qr-code">
        <div className="header">
          <div className="icon" onClick={() => this.props.handleSetScreen(SCREEN.INFO)}><IconArrowLeft /></div>
          <div className="name">{formatMessage(messages.invite_group_title)}</div>
        </div>
        <div class="qr-invite-content">
          <div class="qr-img-content">
            <QRCode
              className={linkState ? 'qr-img' : 'qr-img blur'}
              value={inviteUrl}
              size={176}
            />
          </div>
          <div className='invite_group_desc'>{formatMessage(messages.invite_group_desc)}</div>
          <div className='invite_group_sub_desc'>
            {linkState ? formatMessage(messages.invite_group_sub_desc) : formatMessage(messages.create_qr_link_to_invite)}
          </div>
          {linkState && <div class="text-copy-container">
            <input class="input" type="text" id="myTextField" value={inviteUrl} readonly />
            <div className='button-copy' onClick={this.onCopyUrl}><IconCopy /></div>
          </div>}
          {linkState && <button className='share-button' onClick={this.onShareInviteLink}>{formatMessage(messages.share_link_button)}</button>}
          {linkState ?
            <button className='button-link cancel-link-button' onClick={() => this.onCreateInviteLink(LINK_STATE.DISABLE)}>
              {formatMessage(messages.cancel_link_button)}
            </button> :
            <button className='button-link create-link-button' onClick={() => this.onCreateInviteLink(LINK_STATE.ENABLE)}>
              {formatMessage(messages.create_link_button)}
            </button>}
        </div>
      </div >
    )
  }

}

export default injectIntl(QRCodeInvite);